<template>
  <div class="jujuna-bottle">
      <ShopLocations />
    <div class="container-landing">
      <picture>
        <source media="(max-width:1365px)" srcset="@/assets/img/piramidebii1024.png">
        <source media="(max-width:1439px)" srcset="@/assets/img/piramidebii1366.png">
             <img src="@/assets/img/piramidebipng.png" class="piramidebii">  
      </picture>
   
        <img src="@/assets/img/piramidebii-right.png" class="piramidebii2">
      <div class="left-col">
          <img src="@/assets/img/jujueyes2.png" alt="" class="jujueyes sticker">
          <img src="@/assets/img/drinkcold2.png" alt="" class="drink-cold sticker">
        <img :src="_.get(contentData, 'data.list[0].images[0].url')" alt="" class="bottle-img">
      </div>
      <div class="right-col">
        <div class="ttl-wrapper">
          <div class="bigger-ttl"><h2 class="f-55 w__change">{{ _.get(contentData, 'data.list[0].title') }}</h2></div>
          <div class="lesser-ttl">
            <span class="f-34 bold-italic w__change">{{ _.get(contentData, 'data.list[0].price') }}₾</span>
          </div>
        </div>
        <div class="desc-box">
      
           <div class="col" v-for="(col, index) in this.getProduct[0].newIngredients.newArr" :key="index">
             <span class="f-16 light-italic w__change" v-if="$route.name === 'en'">{{col.front_title_en}}</span>
            <span class="f-16 light-italic w__change" v-if="$route.name === 'ge'">{{col.front_title_ge}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'en'">{{col.descr_en}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'ge'">{{col.descr_ge}}</span>
          </div>
        </div>
       
        <div class="desc" v-html="_.get(contentData, 'data.list[0].description')"></div>

     
         <!-- <router-link :to="getShopLink + '/singleview/' + getProduct[0].id + '-' + getProduct[0].slug" class="buy-btn-comp">
   
      <span class="regular f-30 w__change">{{$fn.tr('შეძენა')}}</span>
    
  </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import BuyBtn  from "@/components/BuyBtn";
import ShopLocations  from "@/components/ShopLocations";
export default {
  props: ['contentData'],
    components: {
        BuyBtn,
        ShopLocations,
    },
    mounted(){
      console.log(this.getVolume)
    },
    computed: {
       getShopLink(){
        let _m = this.$store.state.main.indx.menus;
      let dup = [..._m]
      dup = dup.filter(m => m.configs.includes("shop"))
      return dup[0].full_url;
      },


      
     getProduct(){

      //  return _.get(this.contentData, 'data.list[0]');

        let _l = [..._.get(this.contentData, 'data.list')]; 
         for (let i = 0; i < _l.length; i++) {
            let n = []
           let newIngredients = {
             newArr: n,
           }
          
           _l[i].newIngredients = newIngredients;
           
           let attr = _l[i].allAttributes;

           let _attr = this.$store.state.main.indx.attributes.characteristics;
           for (let k = 0; k < _attr.length; k++) {
             for (let j = 0; j < attr.length; j++) {
               if(attr[j] == _attr[k].id){
                n.push(_attr[k])

               }
               
             }
             
           }
         }
         return _l;
     },


     getAlcohol(){
      let list = [...this.getProduct[0].newIngredients.newArr];
   
      list = list.filter(l => l.slug == 'alcohol');

       return list[0];
    },
     getVolume(){
      let list = [...this.getProduct[0].newIngredients.newArr];
    
      list = list.filter(l => l.slug == 'volume');

      
      return list[0];
    },
         getGas(){
      let list = [...this.getProduct[0].newIngredients.newArr];
      
      list = list.filter(l => l.slug == 'gas');

      
      return list[0];
     
    },

     
    },
    methods: {
        openShopLocations(){
             
      this.$store.commit('main/shopLocationsStatus', !this.$store.state.main.shopLocationActive);
      console.log(this.$store.state.main.shopLocationActive)
        }
    },
     beforeDestroy(){
     this.$store.commit('main/shopLocationsStatus', false);
  }
};
</script>

<style lang="scss" scoped>
.jujuna-bottle .right-col .desc{
 &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup{
    
     font-family: "FiraGO-Italic";
     will-change: transform;
   }
}



</style>
<style lang="scss" scoped>
.buy-btn-comp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../../assets/img/buybtn.png');
  background-size: cover;
  background-repeat: no-repeat;
  width: 173px;
  height: 60px;
  
 
  transition: 0.3s;
  transition-delay: 0.3s;
    span{
        color: white;
    }
 

  transition-delay: 0s;
  transition: all cubic-bezier(0, 0.08, 0.06, 0.99) 0.5s;
  @media (min-width: 1024px) {
    &:hover {
      transform: scale(1.1) rotate(-2deg);
    }
  }
}
</style>
